import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

// Attach JWT on every request
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('ap_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Auto-logout on 401
api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ap_token');
      localStorage.removeItem('ap_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
